export default __webpack_public_path__ + "static/media/orangePlusCircle.c606b0ae.svg";